export const isInteger = (number: any) =>
  typeof number === "number" && number % 1 === 0;
